import { TravelLegType } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";

export const getTravelLegApiEndpoint = (travelLeg: TravelLegType) => {
  switch (travelLeg) {
    case TravelLegType.flight:
      return {
        list: API_ENDPOINTS.EVENT_FLIGHT_TRAVEL_LEGS,
        item: API_ENDPOINTS.EVENT_FLIGHT_TRAVEL_LEG,
      };
    case TravelLegType.bus:
      return {
        list: API_ENDPOINTS.EVENT_BUS_TRAVEL_LEGS,
        item: API_ENDPOINTS.EVENT_BUS_TRAVEL_LEG,
      };
    case TravelLegType.train:
      return {
        list: API_ENDPOINTS.EVENT_TRAIN_TRAVEL_LEGS,
        item: API_ENDPOINTS.EVENT_TRAIN_TRAVEL_LEG,
      };
    default:
    case TravelLegType.other:
      return {
        list: API_ENDPOINTS.EVENT_OTHER_TRAVEL_LEGS,
        item: API_ENDPOINTS.EVENT_OTHER_TRAVEL_LEG,
      };
  }
};

export const getTravelLegDataKey = (travelLeg: TravelLegType) => {
  switch (travelLeg) {
    case TravelLegType.flight:
      return IDataKeys.eventFlightTravelLeg;
    case TravelLegType.bus:
      return IDataKeys.eventBusTravelLeg;
    case TravelLegType.train:
      return IDataKeys.eventTrainTravelLeg;
    default:
    case TravelLegType.other:
      return IDataKeys.eventOtherTravelLeg;
  }
};
